import * as React from "react";
import { StyledHeader, DropdownMenu } from "./styles";
import { HeaderTypeProps } from "./types";

import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBookingEngine } from "../../context/BookingEngineContext";

import assets from "../../assets";

import { useTheme } from "../../hooks";

export const Header = ({ onClick, hideText }: HeaderTypeProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const { bookingEngineData } = useBookingEngine();
  const [showDropdown, setShowDropdown] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const { themeMode, toggleTheme } = useTheme();

  const hostLogo = bookingEngineData?.logoImage?.urls?.big ?? assets.Logo;

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleThemeToggle = () => {
    toggleTheme();
    setShowDropdown(false);
  };

  const handleDropdownToggle = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowDropdown(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isActive = (path: string) => location.pathname === path;
  return (
    <StyledHeader onClick={onClick}>
      <img className="logo" src={hostLogo} alt="Host logo" />

      <div className="navigation-desktop">
        <span
          onClick={() => navigate("/home")}
          className={isActive("/home") ? "active" : ""}
        >
          Home
        </span>
        <span
          onClick={() => navigate("/reservations")}
          className={isActive("/reservations") ? "active" : ""}
        >
          Reservations
        </span>
        <span
          onClick={() => navigate("/explore")}
          className={isActive("/explore") ? "active" : ""}
        >
          Guidebooks
        </span>
        <span
          onClick={() => navigate("/inbox")}
          className={isActive("/inbox") ? "active" : ""}
        >
          Inbox
        </span>
      </div>

      <div className="logout-container" ref={dropdownRef}>
        <img
          src={assets.userIcon}
          alt="logout"
          className="logout-icon"
          onClick={handleDropdownToggle}
        />
        {showDropdown && (
          <DropdownMenu>
            <span onClick={handleThemeToggle}>
              {themeMode === "light"
                ? "Switch to Dark Mode"
                : "Switch to Light Mode"}
            </span>
            <span onClick={handleLogout}>Log Out</span>
          </DropdownMenu>
        )}
      </div>
    </StyledHeader>
  );
};
